import styled from 'styled-components';
import heroBanner from '../../../assets/images/heroBanner1.webp';

const Container = styled.div`
  display: grid;
  height: 100vh;
  background-image: url(${heroBanner});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media only screen and (min-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const SectionA = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: rgba(10, 31, 48, 0.94);
  color: #fff;
  justify-content: center;
  padding: 20px;
  > div {
    max-width: 521px;
    margin: 0 auto;
  }
  img {
    margin-bottom: 28px;
  }
  h3 {
    font-size: 24px;
    font-family: 'latoregular';
    margin-bottom: 16px;
  }
  h2 {
    font-size: clamp(40px, 5.5vw, 60px);
    font-family: 'latobold';
    margin-bottom: 9px;
  }
  p {
    font-size: 20px;
    font-family: 'latomedium';
  }
`;
const SectionB = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  > div {
    margin: 0 auto;
    .star {
      color: #a30202;
    }
    h3 {
      font-size: 28px;
      font-family: "latomedium";
      margin-bottom: 13px;
    }
    h5 {
      margin-bottom: 30px;
    }
    h2 {
      font-size: 22px;
      margin-bottom: 13px;
    }
    Button {
      width: 100%;
      height: 36px;
      text-transform: uppercase;
      margin-top: 25px;
    }
    p {
      font-size: 13px;
    }
  }
`;

export { Container, SectionA, SectionB };
